import Icon from '../Icon';
import type { IconNode, LucideProps } from '../types';

const iconNode: IconNode = [
  ['path', { d: 'M14 4a1 1 0 0 1 1-1', key: 'dhj8ez' }],
  ['path', { d: 'M15 10a1 1 0 0 1-1-1', key: '1mnyi5' }],
  ['path', { d: 'M21 4a1 1 0 0 0-1-1', key: 'sfs9ap' }],
  ['path', { d: 'M21 9a1 1 0 0 1-1 1', key: 'mp6qeo' }],
  ['path', { d: 'm3 7 3 3 3-3', key: 'x25e72' }],
  ['path', { d: 'M6 10V5a2 2 0 0 1 2-2h2', key: '15xut4' }],
  ['rect', { x: '3', y: '14', width: '7', height: '7', rx: '1', key: '1bkyp8' }],
];

/**
 * @component @name Replace
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgNGExIDEgMCAwIDEgMS0xIiAvPgogIDxwYXRoIGQ9Ik0xNSAxMGExIDEgMCAwIDEtMS0xIiAvPgogIDxwYXRoIGQ9Ik0yMSA0YTEgMSAwIDAgMC0xLTEiIC8+CiAgPHBhdGggZD0iTTIxIDlhMSAxIDAgMCAxLTEgMSIgLz4KICA8cGF0aCBkPSJtMyA3IDMgMyAzLTMiIC8+CiAgPHBhdGggZD0iTTYgMTBWNWEyIDIgMCAwIDEgMi0yaDIiIC8+CiAgPHJlY3QgeD0iMyIgeT0iMTQiIHdpZHRoPSI3IiBoZWlnaHQ9IjciIHJ4PSIxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/replace
 * @see https://lucide.dev/guide/packages/lucide-solid - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Replace = (props: LucideProps) => <Icon {...props} iconNode={iconNode} name="replace" />;

export default Replace;
